import { TRootState } from '@/redux/rootReducer';
import { ECheckoutSteps, EStatus } from '@/services/types/core/checkoutSteps';

import { isOutdoorsyStayBookingOrQuote } from '../bill/data';
import { getBookingCheckoutQuestions } from './booking';

export const getCheckoutSteps = (state: TRootState) => {
  let checkoutSteps = state.checkout?.checkoutSteps;
  const listingData = state.listing.data;
  const isOutdoorsyStay = isOutdoorsyStayBookingOrQuote(state);
  const checkoutQuestions = getBookingCheckoutQuestions(state);

  // create checkout steps when there is no booking info
  if (!checkoutSteps) {
    checkoutSteps = {
      id: 0,
      steps: [],
    };
    checkoutSteps.steps.push({
      name: ECheckoutSteps.INFO,
      order: checkoutSteps.steps.length + 1,
      status: EStatus.INCOMPLETE,
    });

    if (listingData?.has_checkout_questions) {
      // All dealer owned listings will say `has_checkout_questions` to be true because we inject
      // the pickup and dropoff questions. For RV/Campsite bundles, we do not want to inject that
      // question and will only show the step if there are other questions.
      if (!isOutdoorsyStay || (checkoutQuestions && checkoutQuestions.length > 0)) {
        checkoutSteps.steps.push({
          name: ECheckoutSteps.QUESTIONS,
          order: checkoutSteps.steps.length + 1,
          status: EStatus.INCOMPLETE,
        });
      }
    }

    checkoutSteps.steps.push({
      name: ECheckoutSteps.PAYMENT,
      order: checkoutSteps.steps.length + 1,
      status: EStatus.INCOMPLETE,
    });

    checkoutSteps.steps.push({
      name: ECheckoutSteps.CONFIRMATION,
      order: checkoutSteps.steps.length + 1,
      status: EStatus.INCOMPLETE,
    });
  }

  return checkoutSteps;
};
